module.exports = __webpack_public_path__ + "img/Sommelier_MarianaRivera.ed1604b5.jpeg";